import React, {useState, useEffect} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";


const UserWalletStatementEdit = ()=>{
     const [date, setDate ] = useState('');
     const [user, setUser ] = useState('');
     const [deposit, setDeposit ] = useState('');
     const [withdrawal, setWithdrawal ] = useState('');
     const [trxCode, setTrxCode ] = useState('');
     const [fee, setFee ] = useState('');
    const [redirect, setRedirect] = useState(false);


    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`userWalletStatement/${id}`);
                 setDate(data.date);
                 setUser(data.user);
                 setDeposit(data.deposit);
                 setWithdrawal(data.withdrawal);
                 setTrxCode(data.trx_code);
                 setFee(data.fee);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`userWalletStatement/${id}`, {
            date,
            user,
            deposit,
            withdrawal,
            trxCode,
            fee,
        });
        console.log(data);
        setRedirect(true);
    };
   
    if(redirect){
         return <Navigate to={'/userWalletStatement'} />
    }
    return (
        <Wrapper pageTitle={'Edit UserWalletStatement'}>
            <InnerNav createLink={'/userWalletStatementCreate'} listLink={'/userWalletStatement'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Date </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Date" value={date}
                        onChange = {e => setDate(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">User </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="User" value={user}
                        onChange = {e => setUser(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Deposit </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Deposit" value={deposit}
                        onChange = {e => setDeposit(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Withdrawal </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Withdrawal" value={withdrawal}
                        onChange = {e => setWithdrawal(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TrxCode </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TrxCode" value={trxCode}
                        onChange = {e => setTrxCode(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Fee </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Fee" value={fee}
                        onChange = {e => setFee(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default UserWalletStatementEdit;